/**
 * Состояние баланса: считается ОТ СУММЫ ТОКЕНОВ, простыми порогами
 * (решение владельца 2026-07-29).
 *
 * Раньше считалось от цены генераций («хватит на N»): 4000 токенов — это
 * 90 фото по 45 или всего 10 видео по 400, и фиксированный порог врал бы
 * обеим группам. Идея верная, но цену брали у ВЫБРАННОЙ модели, а она
 * зависит от страницы: на главной модель сбрасывается при загрузке
 * (App.tsx, ветка mediaPage), на /generate — нет. Из-за этого одна и та же
 * главная на одном балансе показывала то «пора пополнять», то тишину —
 * в зависимости от того, заходил ли юзер до этого в генератор, и подсветка
 * возвращалась только после F5. Пороги от суммы такого класса багов не
 * имеют вовсе: состояние зависит только от баланса.
 *
 * Если вернёмся к счёту в генерациях — брать цену надо не из глобального
 * выбора модели, а из того, что юзер видит на текущем экране.
 */

export type CreditsLevel = 'ok' | 'low' | 'critical' | 'empty'

/** Ниже — жёлтая пилюля «заканчиваются». */
export const LOW_BALANCE = 100
/** Ниже — красная «почти ноль». */
export const CRITICAL_BALANCE = 30
/** С этой суммы пилюля начинает наливаться жёлтым. */
export const WARM_FROM_BALANCE = 200
/** Шаг заливки в токенах: шкала движется заметными ступенями, а не незримо. */
export const FILL_STEP = 10

export interface CreditsState {
	level: CreditsLevel
	/** Доля жёлтой заливки пилюли слева направо: 0 при 200+ токенах, 1 при 100
	 *  и ниже. Ступенями по FILL_STEP токенов. Едет в --credits-warm. */
	warm: number
	/** Доля красной заливки ПОВЕРХ жёлтой: 0 при 100+, 1 у самого нуля.
	 *  Жёлтый при этом никуда не девается — красный наливается по нему, так
	 *  что шкала читается как одно непрерывное движение, а не как смена
	 *  двух разных индикаторов. Едет в --credits-alarm. */
	alarm: number
}

/** Доля 0…1 ступенями по FILL_STEP токенов внутри диапазона.
 *
 *  Округление ВВЕРХ, а не к ближайшему: иначе первый шаг набирался только к
 *  середине ступени, и сразу за порогом шкала стояла на месте — 99 токенов
 *  выглядели ровно как 100, красная волна трогалась лишь с 95. Вверх — значит
 *  «потратил хоть что-то из новой сотни → шкала сдвинулась». */
function stepped(passed: number, span: number): number {
	if (passed <= 0) return 0
	if (passed >= span) return 1
	const steps = Math.round(span / FILL_STEP)
	return Math.ceil((passed / span) * steps) / steps
}

/**
 * @param credits баланс юзера в токенах
 *
 * 0 — «empty»: пилюля превращается в кнопку «Пополнить» (цифра «0» ничего
 * не подсказывает). До 30 — «critical» (красная), до 100 — «low» (жёлтая),
 * дальше — «ok». Но от 200 к 100 подложка уже плавно теплеет (warm), так что
 * жёлтая зона не наступает внезапно.
 */
export function creditsState(credits: number): CreditsState {
	const balance = Math.max(0, Math.floor(credits || 0))
	// Жёлтая шкала: 200 → 100. Красная: 100 → 0, поверх полностью жёлтой.
	const warm = stepped(WARM_FROM_BALANCE - balance, WARM_FROM_BALANCE - LOW_BALANCE)
	const alarm = stepped(LOW_BALANCE - balance, LOW_BALANCE)
	if (balance <= 0) return { level: 'empty', warm, alarm }
	if (balance < CRITICAL_BALANCE) return { level: 'critical', warm, alarm }
	if (balance < LOW_BALANCE) return { level: 'low', warm, alarm }
	return { level: 'ok', warm, alarm }
}

/** Тон иконки-искры под состояние (см. icons/Coin). */
export function creditsTone(level: CreditsLevel): 'brand' | 'warn' | 'danger' {
	if (level === 'empty' || level === 'critical') return 'danger'
	if (level === 'low') return 'warn'
	return 'brand'
}

/**
 * Оплаченный период: подписка active/trial или разовый пакет в сроке (subscription_expires_at живёт и у разовых —
 * конец пакета). Такому человеку «Пополнить» открывает докупку токенов, остальным — тарифы: у купившего вопрос «где
 * ещё токенов», а не «какой тариф выбрать» (решение владельца 2026-08-08). Одно правило для шапки и плашки нехватки.
 */
export function hasPaidPeriod(
	user: { subscription_status?: string | null; subscription_expires_at?: string | null } | null | undefined,
	now: number,
): boolean {
	if (!user) return false
	if (['active', 'trial'].includes(user.subscription_status ?? '')) return true
	return !!user.subscription_expires_at && new Date(user.subscription_expires_at).getTime() > now
}
